module.exports = __webpack_public_path__ + "static/media/products.51e0274a.jpeg";